/**
 * V2 Cart — qty / remove via Cart Ajax + Section Rendering API.
 * Live /cart. Old cart: /cart?view=v1. Does not use jquery.cart.min.js.
 */
(function () {
  const ROOT_SELECTOR = '[data-v2-cart]';
  const DESKTOP_MQ = '(min-width: 1200px)';

  function cartRoot() {
    return document.querySelector(ROOT_SELECTOR);
  }

  function statusEl(root) {
    return root.querySelector('[data-v2-cart-status]');
  }

  function setStatus(root, message) {
    const el = statusEl(root);
    if (!el) return;
    el.textContent = message || '';
  }

  function syncCtaOffset(root) {
    if (!root) return;
    const cta = root.querySelector('[data-v2-cart-cta]');
    if (!cta || window.matchMedia(DESKTOP_MQ).matches) {
      root.style.removeProperty('--v2-cart-cta-offset');
      return;
    }
    root.style.setProperty('--v2-cart-cta-offset', `${cta.offsetHeight}px`);
  }

  function syncChromeOffset(root) {
    if (!root || root.classList.contains('v2-cart--preview')) {
      if (root) root.style.removeProperty('--v2-cart-chrome-offset');
      return;
    }
    const top = root.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
    root.style.setProperty('--v2-cart-chrome-offset', `${Math.max(0, Math.floor(top))}px`);
  }

  function syncStickyTop(root) {
    if (!root || root.classList.contains('v2-cart--preview') || !window.matchMedia(DESKTOP_MQ).matches) {
      if (root) root.style.removeProperty('--v2-cart-sticky-header');
      return;
    }

    const header = document.querySelector('.main-header-new');
    let offset = 0;
    if (header && !header.classList.contains('hidden')) {
      offset = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    }
    root.style.setProperty('--v2-cart-sticky-header', `${offset}px`);
  }

  function syncLayout(root) {
    syncCtaOffset(root);
    syncChromeOffset(root);
    syncStickyTop(root);
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.header-cart-count, .main-header-new__cart-count').forEach(function (el) {
      el.textContent = String(count);
      el.classList.toggle('active', count > 0);
    });
    document.querySelectorAll('.main-header-new__cart').forEach(function (el) {
      el.classList.toggle('active', count > 0);
    });
  }

  function changeUrl() {
    const rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return `${rootPath}cart/change.js`;
  }

  async function refreshSection(root) {
    const sectionId = root.getAttribute('data-v2-cart-section-id');
    if (!sectionId) return;

    const url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);

    const response = await fetch(url.toString());
    if (!response.ok) {
      throw new Error('Section refresh failed');
    }

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const wrapperId = `shopify-section-${sectionId}`;
    const currentWrapper = document.getElementById(wrapperId);
    const nextWrapper = doc.getElementById(wrapperId);

    if (currentWrapper && nextWrapper) {
      currentWrapper.replaceWith(nextWrapper);
    } else {
      const nextRoot = doc.querySelector(ROOT_SELECTOR);
      if (nextRoot) root.replaceWith(nextRoot);
    }

    const next = cartRoot();
    syncLayout(next);
  }

  async function changeLine(root, key, quantity) {
    if (root.classList.contains('is-updating')) return;

    root.classList.add('is-updating');
    root.setAttribute('aria-busy', 'true');
    setStatus(root, '');

    try {
      const response = await fetch(changeUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(key), quantity: Number(quantity) }),
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        const message = data.description || data.message || 'Cart Error';
        setStatus(root, message);
        return;
      }

      updateHeaderCount(data.item_count);
      document.dispatchEvent(new CustomEvent('v2:cart:updated', { detail: data }));
      await refreshSection(root);
    } catch (error) {
      setStatus(root, error.message || 'Cart Error');
    } finally {
      const next = cartRoot();
      if (next) {
        next.classList.remove('is-updating');
        next.removeAttribute('aria-busy');
      }
    }
  }

  function nextQuantity(action, current) {
    if (action === 'remove') return 0;
    if (action === 'plus') return current + 1;
    if (action === 'minus') return Math.max(0, current - 1);
    return current;
  }

  document.addEventListener('click', function (event) {
    const actionEl = event.target.closest('[data-v2-cart-action]');
    if (!actionEl) return;

    const root = actionEl.closest(ROOT_SELECTOR);
    if (!root) return;

    const key = actionEl.getAttribute('data-v2-cart-item-key');
    const action = actionEl.getAttribute('data-v2-cart-action');
    if (!key || !action) return;

    event.preventDefault();

    const current = Number(actionEl.getAttribute('data-v2-cart-quantity') || '0');
    const quantity = nextQuantity(action, current);
    changeLine(root, key, quantity);
  });

  function hideIntercomLauncher(root) {
    if (!root || root.classList.contains('v2-cart--preview')) return;

    function hide() {
      if (typeof window.Intercom === 'function') {
        window.Intercom('update', { hide_default_launcher: true });
      }
    }

    hide();
    window.addEventListener('load', hide);
  }

  function onReady() {
    const root = cartRoot();
    syncLayout(root);
    hideIntercomLauncher(root);
  }

  window.addEventListener('resize', function () {
    syncLayout(cartRoot());
  });

  let stickyTopRaf = 0;
  window.addEventListener(
    'scroll',
    function () {
      if (stickyTopRaf) return;
      stickyTopRaf = window.requestAnimationFrame(function () {
        stickyTopRaf = 0;
        syncStickyTop(cartRoot());
      });
    },
    { passive: true }
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
